import { LocationFilters } from '@hakimo-ui/hakimo/types';
import { FilterItem, searchFilters } from '../location-list/util';

export interface State {
  filters: LocationFilters;
  page: number;
  pageSize: number;
  searchValue: string;
  selectedFilter: FilterItem;
}

export const initialState: State = {
  filters: {
    name: { values: [], negative: false },
  },
  page: 1,
  pageSize: 20,
  searchValue: '',
  selectedFilter: searchFilters[0],
};
